import request from '@/utils/request'

export function myListData(data) {
  return request({
    url: '/qa/userList',
    method: 'post',
    data: data
  })
}

export function openListData(data) {
  return request({
    url: '/qa/publicList',
    method: 'post',
    data: data
  })
}

export function submitForm(data) {
  return request({
    url: '/qa/save',
    method: 'post',
    data: data
  })
}

export function getDatailById(id) {
  return request({
    url: '/qa/detail/' + id,
    method: 'get'
  })
}
